export const ANNOUNCEMENT_TYPES = {
  INFORMATIONAL: "informational",
  WARNING: "warning",
} as const;

export type AnnouncementType =
  (typeof ANNOUNCEMENT_TYPES)[keyof typeof ANNOUNCEMENT_TYPES];

export const ANNOUNCEMENT_TYPE_LABELS: Record<AnnouncementType, string> = {
  [ANNOUNCEMENT_TYPES.INFORMATIONAL]: "Informational",
  [ANNOUNCEMENT_TYPES.WARNING]: "Warning",
};

export const ANNOUNCEMENT_STATUSES = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const;

export type AnnouncementStatus =
  (typeof ANNOUNCEMENT_STATUSES)[keyof typeof ANNOUNCEMENT_STATUSES];

export const ANNOUNCEMENT_STATUS_LABELS: Record<AnnouncementStatus, string> = {
  [ANNOUNCEMENT_STATUSES.ACTIVE]: "Active",
  [ANNOUNCEMENT_STATUSES.INACTIVE]: "Inactive",
};

export interface IAnnouncement {
  id?: string;
  title: string;
  content: string;
  enabled?: boolean;
  type?: AnnouncementType;
  userId?: string;
  displayName?: string;
  createdAt: number;
  updatedAt: number;
}
